module.exports = __webpack_public_path__ + "img/47.16aed058.jpg";